import type { Translation, TranslationLang } from '@skytech/types'

import { LANGUAGE_FLAGS } from './constants'
import { getEntries } from './types'

export function getInitialTranslationsValues({
  translationList,
  translationId,
}: {
  translationList: Record<TranslationLang, Translation> | undefined
  translationId: string
}) {
  const values = getEntries(LANGUAGE_FLAGS).reduce(
    (acc, [locale]) => {
      const currentLocaleTranslations = translationList?.[locale]

      acc[locale] = currentLocaleTranslations ? currentLocaleTranslations[translationId] || '' : ''
      return acc
    },
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {} as Record<TranslationLang, string>
  )
  return values
}
